import { ScopeOfPracticeEnum } from '@umss/shared/utils';
import { CreateLocationDto } from '../location/create-location.dto';
import { FacilityClassification, FacilityType } from '@umss/shared/data-access';

export interface CreateFacilityDto extends CreateNamedEntityDto {
  isActive?: boolean; // Default true
  facilityTypeId: FacilityType;
  classification?: FacilityClassification; // Required
  location?: CreateLocationDto | null;
  contactPhone?: string | null; // Phone validation, max 20 characters
  contactEmail?: string | null; // Email validation, max 255 characters
  websiteUrl?: string | null; // URL validation
  contractSignedDate?: string | null; // DateOnly as ISO string (YYYY-MM-DD)
  supportedScopes?: ScopeOfPracticeEnum[]; // Default empty array
}

export interface CreateNamedEntityDto {
  name: string; // Required, max 255 characters
  description?: string | null; // Optional, max 1000 characters
}
